import { ReactElement, useCallback, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import LoginComponent from './components/login/LoginComponent';
import LogoutComponent from './components/login/LogoutComponent';
import MobileApp from './components/mobile/MobileApp';
import { ACCESS_TOKEN, serviceLogin } from './service/AuthService';

export const App = () : ReactElement => {

  const navigate = useNavigate();

  const isAuthenticated = () => {
    return !!localStorage.getItem(ACCESS_TOKEN);
  };

  const handleLoginSuccess = useCallback(() => {
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (!token) {
      // TODO: remove this after testing
      const startLogin = async () => {
        try {
          const response = await serviceLogin("user", "pass");
          localStorage.setItem(ACCESS_TOKEN, response.data.jwtToken);
          handleLoginSuccess();
        } catch (err: any) {
          console.error('Login failed:', err);
        }
      };
      //startLogin();
    }
  }, [handleLoginSuccess]);


  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated() ? <Navigate to="/" /> : <LoginComponent onLoginSuccess={handleLoginSuccess} />}
      />

      <Route
        path="/"
        element={isAuthenticated() ? <MobileApp /> : <Navigate to="/login" replace />}
      />
      <Route path="/logout" element={<LogoutComponent />} />
    </Routes>
  );
}

export default App;
